export default {"src":"/_next/static/media/success.4d855013.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};